import React from 'react';
import { Icon } from './Icon.js';
export const IconKey4 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 2C15.0376 2 17.5 4.46243 17.5 7.5C17.5 9.63734 16.2808 11.4899 14.5 12.4003L14.5 15.5L13 17L14.5 18.5V20L12 22.5L9.5 20V12.4003C9.32789 12.3123 9.16102 12.2155 9 12.1105C7.4949 11.1292 6.5 9.43078 6.5 7.5C6.5 4.46243 8.96244 2 12 2Z", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M12 6V6.01", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconKey4.js.map